import React from "react";
import { RuleModuleContext } from "../../contexts/RuleModuleContext";
import TextCellInfo from "../gridCells/TextCellInfo";
import RuleItemDataTable from "./RuleItemDataTable";

export default () => {
  const { moduleName, moduleType, list, key } = React.useContext(
    RuleModuleContext
  );
  return (
    <>
      <TextCellInfo
        text={`Rule Module ${moduleName} of type "${moduleType}" has ${list.length} rule items.`}
        dataTest={`module-details-${key}`}
      />
      <RuleItemDataTable ruleItems={list} />
    </>
  );
};
